/**
 * Skeleton-Bausteine für Ladezustände (UX_KONZEPT.md §4 Punkt 1): nie eine
 * leere weiße Fläche, nie Layout-Sprung — Skeleton in Zielgröße.
 */

export function SkeletonZeile({ className = "" }: { className?: string }) {
  return <div className={`h-4 animate-pulse rounded-md bg-slate-200 ${className}`} />
}

/** Tabellen-Skeleton: `zeilen` Platzhalterzeilen mit `spalten` Zellen. */
export function SkeletonTabelle({
  zeilen = 5,
  spalten = 3,
}: {
  zeilen?: number
  spalten?: number
}) {
  return (
    <tbody>
      {Array.from({ length: zeilen }).map((_, i) => (
        <tr key={i} className="border-t border-slate-100">
          {Array.from({ length: spalten }).map((__, j) => (
            <td key={j} className="px-4 py-2.5">
              <SkeletonZeile className={j === 0 ? "w-24" : "w-full max-w-[12rem]"} />
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  )
}
